import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { COLOR_PALETTES } from './contexts/ThemeContext';
import './styles/global.css';

const availableDesigns = ['aurora-glass', 'genz-hyperpop', 'executive-blue', 'premium-dark', 'boutique-green', 'bento-grid', 'enterprise-blue', 'editorial-burgundy'];
const DESIGN_STORAGE_KEY = 'portfolio-design';
let initialDesign = availableDesigns[Math.floor(Math.random() * availableDesigns.length)];
try {
  const saved = localStorage.getItem(DESIGN_STORAGE_KEY);
  if (saved && availableDesigns.includes(saved)) initialDesign = saved;
  else localStorage.setItem(DESIGN_STORAGE_KEY, initialDesign);
} catch (_) { /* storage unavailable */ }
document.documentElement.dataset.design = initialDesign;
let initialLanguage = 'en';
try {
  const savedLanguage = localStorage.getItem('portfolio-language');
  if (savedLanguage === 'ar' || savedLanguage === 'en') initialLanguage = savedLanguage;
} catch (error) {
  // Use English when storage is unavailable.
}
document.documentElement.lang = initialLanguage;
document.documentElement.dir = initialLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.dataset.language = initialLanguage;

let initialMode = 'light';
try {
  initialMode = localStorage.getItem('portfolio-color-mode') || 'light';
} catch (error) {
  // Sandboxed previews may not provide storage access.
}
document.documentElement.classList.toggle('dark-mode', initialMode === 'dark');

const startupPalettes = Object.fromEntries(
  COLOR_PALETTES
    .filter(p => p.colors)
    .map(p => [p.id, [p.colors.primary, p.colors.secondary, p.colors.accent]])
);
try {
  const paletteId = localStorage.getItem('portfolio-color-palette');
  let colors = startupPalettes[paletteId];
  if (paletteId === 'custom') {
    const custom = JSON.parse(localStorage.getItem('portfolio-custom-colors'));
    if (custom?.primary && custom?.secondary && custom?.accent) colors = [custom.primary, custom.secondary, custom.accent];
  }
  if (colors) {
    document.documentElement.style.setProperty('--accent', colors[0]);
    document.documentElement.style.setProperty('--accent-dark', colors[1]);
    document.documentElement.style.setProperty('--accent-light', colors[2]);
  }
} catch (error) {
  // Use the selected design's default palette.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);